module.exports = __webpack_public_path__ + "img/Send me a ticket.b9b715e3.png";